import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "table-aggregated__header" }
const _hoisted_2 = ["colSpan", "rowSpan"]
const _hoisted_3 = ["data-index"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["colspan"]
const _hoisted_6 = {
  key: 0,
  class: "table-aggregated__footer"
}
const _hoisted_7 = { class: "table-aggregated__footer-row" }
const _hoisted_8 = ["colSpan"]
const _hoisted_9 = {
  key: 4,
  class: "table-aggregated__not-found"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableAggregatedProgress = _resolveComponent("TableAggregatedProgress")!
  const _component_FlexRender = _resolveComponent("FlexRender")!
  const _component_LoaderInfinityMore = _resolveComponent("LoaderInfinityMore")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["table-aggregated-section", { 'table-aggregated-section--arrow': _ctx.isArrowNav, 'table-aggregated-section--line': !_ctx.getIsGroupMode }])
  }, [
    (_ctx.getIsProgressiveLoadStrategy)
      ? (_openBlock(), _createBlock(_component_TableAggregatedProgress, {
          key: 0,
          class: "table-aggregated-section__progress",
          meta: _ctx.getMeta,
          options: _ctx.progressBarOptions,
          isLoading: _ctx.isLoading
        }, null, 8, ["meta", "options", "isLoading"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "table-aggregated-section__wrapper",
      ref: "wrapperRef",
      style: _normalizeStyle(_ctx.getWrapperStyle)
    }, [
      (_ctx.getShowIsNotFoundCell || _ctx.getItems.length)
        ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 0 }, _ctx.$attrs, {
            ref: "tableWrapper",
            class: ["table-aggregated-section__content", { 'arrow-nav': _ctx.isArrowNav, 'table-container-new': _ctx.isArrowNav }],
            style: { maxWidth: _ctx.getIsGroupMode ? _ctx.widthTable : '' },
            onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
          }), [
            (_ctx.table)
              ? (_openBlock(), _createElementBlock("table", {
                  key: 0,
                  class: _normalizeClass(["table-aggregated", { 'table-aggregated--line': !_ctx.getIsGroupMode }]),
                  style: _normalizeStyle({ height: _ctx.getTotalSize })
                }, [
                  _createElementVNode("thead", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.table.getHeaderGroups(), (headerGroup) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "table-aggregated__header-row",
                        key: headerGroup.id
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerGroup.headers, (header) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: header.id
                          }, [
                            (_ctx.isShowHeaderCell(header))
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 0,
                                  class: _normalizeClass(["table-aggregated__cell table-aggregated__header-cell", [
                    _ctx.getHeaderMetaClass(header),
                    {
                      'table-aggregated__cell--fixed': _ctx.getIsCellFixed(header),
                      'table-aggregated__header-cell--last-fixed': _ctx.getIsLastFixedColumn(header.column),
                    },
                  ]]),
                                  colSpan: header.colSpan,
                                  rowSpan: _ctx.calculateHeaderRowSpan(header),
                                  style: _normalizeStyle(_ctx.getHeaderStyle(header))
                                }, [
                                  _createVNode(_component_FlexRender, {
                                    render: header.column.columnDef.header,
                                    props: header.getContext()
                                  }, null, 8, ["render", "props"])
                                ], 14, _hoisted_2))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("tbody", {
                    class: "table-aggregated__body",
                    style: _normalizeStyle({
              height: _ctx.getTotalSize,
            })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVirtualRows, (row) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: _normalizeClass(["table-aggregated__row", [
                _ctx.getRowClass(row),
                { 'table-aggregated__row--non-virtual': _ctx.tablePdfExportVirtualizationDisabled },
              ]]),
                        "data-index": row.index,
                        ref_for: true,
                        ref: _ctx.measureElement,
                        key: _ctx.getRows[row.index]?.id,
                        style: _normalizeStyle({
                transform: _ctx.tablePdfExportVirtualizationDisabled ? 'none' : `translateY(${row.start}px)`,
              })
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRows[row.index]?.getVisibleCells(), (cell) => {
                          return (_openBlock(), _createElementBlock("td", {
                            class: _normalizeClass(["table-aggregated__cell table-aggregated__row-cell", [
                  _ctx.cellClassGetter?.(cell),
                  _ctx.getCellMetaClass(cell),
                  {
                    'table-aggregated__row-cell--has-rowspan': _ctx.getIsRowspan(cell),
                    'table-aggregated__row-cell--hidden-in-rowspan': _ctx.getIsHideCell(cell),
                    'table-aggregated__row-cell--last-in-rowspan': _ctx.getIsLastRowspan(cell),
                    'table-aggregated__row-cell--has-colspan': _ctx.getIsColspan(cell),
                    'table-aggregated__row-cell--hidden-in-colspan': _ctx.getIsHideCellForColspan(cell),
                    'table-aggregated__row-cell--last-in-colspan': _ctx.getIsLastColspan(cell),
                    'table-aggregated__cell--fixed': _ctx.getIsCellFixed(cell),
                  },
                ]]),
                            key: cell.id,
                            style: _normalizeStyle(_ctx.getCellStyle(cell))
                          }, [
                            _createVNode(_component_FlexRender, {
                              render: cell.column.columnDef.cell,
                              props: cell.getContext()
                            }, null, 8, ["render", "props"])
                          ], 6))
                        }), 128))
                      ], 14, _hoisted_3))
                    }), 128)),
                    (_ctx.getShowIsNotFoundCell)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                          _createElementVNode("td", {
                            class: "table-aggregated__not-found",
                            colspan: _ctx.getEmptyCellColspan
                          }, _toDisplayString(_ctx.emptyText), 9, _hoisted_5)
                        ]))
                      : _createCommentVNode("", true)
                  ], 4),
                  (_ctx.footerRenderer && !_ctx.getShowIsNotFound)
                    ? (_openBlock(), _createElementBlock("tfoot", _hoisted_6, [
                        _createElementVNode("tr", _hoisted_7, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerRenderer(_ctx.getFooterParams), (cell, index) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: index,
                              class: _normalizeClass(["table-aggregated__cell table-aggregated__footer-cell", cell.class]),
                              colSpan: cell.colSpan || 1
                            }, _toDisplayString(cell.text), 11, _hoisted_8))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 6))
              : _createCommentVNode("", true)
          ], 16))
        : _createCommentVNode("", true),
      (_ctx.isLoadingMore && _ctx.getIsInfinityScrollLoadStrategy)
        ? (_openBlock(), _createBlock(_component_LoaderInfinityMore, {
            key: 1,
            class: "table-aggregated__more-loader"
          }))
        : _createCommentVNode("", true),
      (_ctx.isLoading || _ctx.isPreparing)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["table-aggregated__loader", {
          'table-aggregated__loader--empty': !_ctx.getItems.length,
          'table-aggregated__loader--progress': _ctx.getIsProgressiveLoadStrategy,
        }]),
            style: _normalizeStyle({ width: _ctx.loaderWidth })
          }, [
            _createVNode(_component_Loader)
          ], 6))
        : _createCommentVNode("", true),
      (_ctx.isLoadingMore && _ctx.getIsInfinityScrollLoadStrategy)
        ? (_openBlock(), _createBlock(_component_LoaderInfinityMore, {
            key: 3,
            class: "table-aggregated__more-loader"
          }))
        : _createCommentVNode("", true),
      (_ctx.getShowIsNotFoundOutside)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.emptyText), 1))
        : _createCommentVNode("", true)
    ], 4)
  ], 2))
}